import { Grid } from "@mui/material";
import Select from "react-select";
import EditButton from "../../Utils/Botones/EditButton";
import TrashIcon from "../TrashIcon";

const DynamicSelectTable = ({
  columnTitle,
  rows = [],
  addRow,
  removeRow,
  options,
  values,
  setValues,
}) => {
  return (
    <Grid
      item
      xs={12}
      className="consult-tab-option_center"
      style={{ marginTop: "2%" }}
    >
      {/* Add row button */}
      <div
        style={{
          display: "flex",
          justifyContent: "right",
          marginBottom: "2%",
          marginRight: "5%",
          height: "30px",
        }}
      >
        <EditButton onClick={() => addRow(rows)}>Agregar</EditButton>
      </div>

      {/* Table */}
      <div>
        <table
          className="input-table"
          style={{ width: "78%", marginTop: "1%" }}
        >
          <thead>
            <tr>
              <th colSpan={2}>{columnTitle}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((_, i) => (
              <tr key={i}>
                <td>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Select
                      id={`${columnTitle}-${i}`}
                      className="select-modal-container"
                      classNamePrefix="select-modal"
                      style={{ width: "90%" }}
                      options={options.filter(
                        (opt) =>
                          !values.some(
                            (v, idx) => idx !== i && v?.value === opt.value
                          )
                      )}
                      value={values?.[i] || null}
                      onChange={(selected) => {
                        const newValues = [...values];
                        newValues[i] = selected;
                        setValues(newValues);
                      }}
                      isClearable={true}
                    />
                  </div>
                </td>
                <td>
                  <div
                    className="table-delete"
                    style={{
                      marginInline: "auto",
                      zIndex: 99,
                      cursor: "pointer",
                    }}
                    onClick={() => removeRow(i)}
                  >
                    <TrashIcon />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Grid>
  );
};

export default DynamicSelectTable;
